import React, { useEffect, useRef, useState } from "react";
import { MapContainer } from "react-leaflet";
import { TileLayer, Marker, Polyline, Popup } from "react-leaflet";
import "leaflet/dist/leaflet.css";
import L from "leaflet";
import busstop from "../../Images/busstop.png";
import { useMap } from "react-leaflet";
import { getroutemapdata } from "../../services/TransportService";
import { Spinner } from "react-bootstrap";
import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
} from "@mui/material";
import IconButton from "@mui/material/IconButton";
import { IoCloseOutline } from "react-icons/io5";
const containerStyle = {
  height: "70vh",
  width: "100%",
};
const getStopIcon = L.icon({
  iconUrl: busstop,
  iconSize: [30, 30],
  iconAnchor: [15, 15],
});
const MapInitializer = ({ onMapReady }) => {
  const map = useMap();
  useEffect(() => {
    if (map) {
      onMapReady(map);
    }
  }, [map]);
  return null;
};
const FitBoundsOnLoad = ({ polyline }) => {
  const map = useMap();
  useEffect(() => {
    if (!polyline?.length) return;
    const flipped = polyline.map(([lng, lat]) => [lat, lng]);
    const bounds = L.latLngBounds(flipped);
    map.fitBounds(bounds, { padding: [50, 50] });
  }, [polyline]);
  return null;
};
const Routemap = ({ id, open, handleclose }) => {
  const mapRef = useRef(null);
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  useEffect(() => {
    if (open) {
      setLoading(true);
      getroutemapdata(id)
        .then((res) => {
          setData(res?.data.data);
        })
        .catch((err) => {
          setError(
            err?.response?.data?.message ||
              err?.response?.data?.error ||
              "Please Trye After Sometime"
          );
        })
        .finally(() => {
          setLoading(false);
        });
    }
  }, [open, id]);
  return (
    <Dialog open={open} onClose={handleclose} fullWidth maxWidth="md">
      <DialogTitle sx={{ m: 0, p: 2 }}>
        {data?.name || "NA"}({data?.route_number})
        <IconButton
          aria-label="close"
          onClick={handleclose}
          sx={{
            position: "absolute",
            right: 8,
            top: 8,
            color: (theme) => theme.palette.grey[500],
          }}
        >
          <IoCloseOutline />
        </IconButton>
      </DialogTitle>
      <DialogContent
        dividers
        sx={{
          p: "0", // fixed height in px
        }}
      >
        <DialogContentText
          sx={{
            p: "0", // fixed height in px
          }}
        >
          <div
            className="card"
            style={{ overflow: "hidden", minHeight: "30vh" }}
          >
            {error && <div className="alert alert-danger m-2">{error}</div>}
            {loading ? (
              <div className="text-center mt-2">
                <Spinner animation="border" />
              </div>
            ) : (
              <MapContainer
                center={[19.076, 72.8777]}
                zoom={14}
                style={containerStyle}
                attributionControl={false}
              >
                <MapInitializer
                  onMapReady={(mapInstance) => {
                    mapRef.current = mapInstance;
                  }}
                />
                <FitBoundsOnLoad polyline={data?.polyline} />
                <TileLayer url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png" />
                {Array.isArray(data?.polyline) && data.polyline.length > 0 && (
                  <Polyline
                    positions={data.polyline.map(([lng, lat]) => [lat, lng])}
                    color="blue"
                    weight={5}
                  />
                )}

                {data?.stops?.map((item) => {
                  return (
                    <Marker
                      position={[item?.latitude, item?.longitude]}
                      icon={getStopIcon}
                    >
                      <Popup>
                        <span className="fw-semibold">{item?.name}</span>
                      </Popup>
                    </Marker>
                  );
                })}
              </MapContainer>
            )}
          </div>
        </DialogContentText>
      </DialogContent>
    </Dialog>
  );
};

export default Routemap;
